import addDotsToPrice from "../price-format";

// component hiển thị tổng tiền
const CartTotal = (props) => {
  return (
    <div className="cart_total_wrapper">
      <h4 className="text-info">Tổng tiền</h4>
      <p className="cart_total">
        <span>Subtotal:</span>
        <span className="text-primary ms-2">
          {addDotsToPrice(props.totalPrice)}
        </span>
      </p>
      <hr className="my-2" />
      <p className="cart_total">
        <span>Total:</span>
        <span className="cart_total_price">
          {addDotsToPrice(props.totalPrice)}
        </span>
      </p>
    </div>
  );
};

export default CartTotal;
